import React, { useState } from 'react';
import { Card } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronDown } from '@fortawesome/free-solid-svg-icons';
import './expandable-card.css';

export function ExpandableCard({ title, border, id, children, defaultExpanded = true }) {
    const [isExpanded, setIsExpanded] = useState(defaultExpanded);

    const toggleExpanded = () => {
        setIsExpanded(!isExpanded);
    };

    return (
        <Card className="expandable-card" border={border}>
            <Card.Header className="expandable-card-header" onClick={toggleExpanded}>
                <Card.Title className="mb-0" id={id}>
                    {title}
                </Card.Title>
                <FontAwesomeIcon icon={faChevronDown} className={`chevron-icon ${isExpanded ? 'rotated' : ''}`} />
            </Card.Header>
            <div className={`expandable-card-content ${isExpanded ? 'expanded' : 'collapsed'}`}>
                <Card.Body>{children}</Card.Body>
            </div>
        </Card>
    );
}
